import { render, staticRenderFns } from "./ActivityLogsView.vue?vue&type=template&id=a1f5676a"
import script from "./ActivityLogsView.vue?vue&type=script&lang=js"
export * from "./ActivityLogsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports